<template>
  <div :class="componentClassName">
    <a-page-heading>電話番号管理 </a-page-heading>
    <m-section>
      <m-action-card title="電話番号管理" icon="user-setting" :help="true" @help:click="helpModalVisible = true">
        <template #action>
          <a-button
            v-if="isAllowModify"
            v-show="number050List.length > 0"
            id="addNew050Number"
            variant="fill"
            size="small"
            label="050番号追加"
            color="primary"
            icon="plus"
            icon-color="white"
            :inline="true"
            style="margin-bottom: 1em"
            @click="handleClickAddNew050Number"
          />
        </template>
        <m-data-table ref="dataTable" :empty-text="dataTableEmptyText" :fit="true" :data="tableData">
          <a-data-table-column prop="" label="050番号" align="left">
            <template #default="scope">
              <span>{{ scope.row.number }}</span>
              &nbsp;
              <a-button
                v-if="isAllowModify && scope.row.statusRaw === 'allocated'"
                :id="'cancel050Number' + scope.row.number"
                variant="fill"
                size="small"
                label="廃止申し込み"
                color="grey"
                :inline="true"
                @click="handleCancel050ButtonClick(scope.row)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="" label="番号名称" align="left">
            <template #default="scope">
              <a-button
                v-if="canEditNumberName && !scope.row.numberName && scope.row.statusRaw !== 'aging'"
                :id="'addNumberName' + scope.row.number"
                variant="text"
                size="small"
                :label="HYPHEN"
                color="primary"
                :inline="true"
                @click="
                  editNumberNameModal = {
                    visible: true,
                    step: 1,
                    numberName: '',
                    selected050Number: scope.row.number,
                  }
                "
              />
              <div v-else>
                <span>{{ scope.row.numberName }}</span>
                &nbsp;
                <a-button
                  v-if="canEditNumberName && scope.row.statusRaw !== 'aging'"
                  :id="'editNumberName' + scope.row.number"
                  variant="fill"
                  size="small"
                  label="編集"
                  color="primary"
                  :inline="true"
                  @click="
                    editNumberNameModal = {
                      visible: true,
                      step: 1,
                      numberName: scope.row.numberName,
                      selected050Number: scope.row.number,
                    }
                  "
                />
              </div>
            </template>
          </a-data-table-column>
          <a-data-table-column prop="" label="フリーダイヤル<br>ナビダイヤル" align="left">
            <template #default="scope">
              {{ scope.row.FDNDNumber }}&nbsp;
              <a-button
                v-if="
                  isAllowModify &&
                  scope.row.actionButton === 'application' &&
                  ['allocated', 'suspended'].includes(scope.row.statusRaw)
                "
                :id="'registerNumberBtn' + scope.row.number"
                variant="fill"
                size="small"
                label="申し込み"
                color="primary"
                :inline="true"
                @click="
                  registerModalVisible = true;
                  registerStep = 1;
                  isLoading = false;
                  contractedPhonenumber = scope.row.number;
                  numberOfLines = 100;
                  registerAgree = false;
                  termClicked = false;
                  precautionClicked = false;
                "
              />
              <a-button
                v-if="
                  isAllowModify &&
                  scope.row.actionButton === 'cancel' &&
                  ['allocated', 'suspended'].includes(scope.row.statusRaw)
                "
                :id="'cancelNumberBtn' + scope.row.number"
                variant="fill"
                size="small"
                label="廃止申し込み"
                color="grey"
                :inline="true"
                @click="
                  isLoading = false;
                  cancelAgree = false;
                  cancelStep = 1;
                  cancelModalVisible = true;
                  cancelFDNDNumber = scope.row.FDNDNumber;
                  contractedPhonenumber = scope.row.number;
                "
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="" label="050番号<br>ステータス" align="left">
            <template #default="scope">
              {{ scope.row.numberStatus }}
            </template>
          </a-data-table-column>
          <a-data-table-column prop="suspendedDate" label="利用停止日" align="left" />
          <a-data-table-column prop="" label="050番号<br>ステータス更新日" align="left">
            <template #default="scope">
              {{ scope.row.numberUpdateDate }}
            </template>
          </a-data-table-column>
          <a-data-table-column prop="" label="フリーダイヤル<br>ナビダイヤル<br>ステータス" align="left">
            <template #default="scope">
              {{ scope.row.FDNDNumberStatus }}
            </template>
          </a-data-table-column>
          <a-data-table-column prop="" label="フリーダイヤル<br>ナビダイヤル<br>ステータス更新日" align="left">
            <template #default="scope">
              {{ scope.row.FDNDNumberUpdateDate }}
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
    <!-- 申し込みモダール -->
    <teleport to="body">
      <o-modal
        id="registerModal"
        v-model:visible="registerModalVisible"
        class="o-modal-remove-phone-number-confirmation t-number-mgmt-general"
        footer-variant="confirmation"
        width="482px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
      >
        <div v-if="registerStep === 1" id="register-step1" class="t-register-step1">
          <a-text :center="true">
            <p id="registerModal-select-text">どちらかを選択してください。</p>
          </a-text>
          <table>
            <tr>
              <td>
                <img
                  id="freeDialLogo"
                  src="@/images/freedial_logo.svg"
                  alt="フリーダイヤル"
                  width="139"
                  height="80"
                  style="padding: 3px; cursor: pointer"
                  @click="
                    registerStep = 2;
                    registerStep1SelectedValue = 'free-dial';
                    registerNumber =
                      stockTelNumber0120.length > 0
                        ? stockTelNumber0120[0]
                        : stockTelNumber0800.length > 0
                        ? stockTelNumber0800[0]
                        : '';
                  "
                />
              </td>
              <td>
                <img
                  id="naviDialLogo"
                  src="@/images/navidial_logo.svg"
                  alt="ナビダイヤル"
                  width="139"
                  height="80"
                  style="padding: 3px; cursor: pointer"
                  @click="
                    registerStep = 2;
                    registerStep1SelectedValue = 'navi-dial';
                    registerNumber = stockTelNumber0570.length > 0 ? stockTelNumber0570[0] : '';
                  "
                />
              </td>
            </tr>
            <tr>
              <td>フリーダイヤル<br />お申し込み</td>
              <td>ナビダイヤル<br />お申し込み</td>
            </tr>
          </table>
        </div>
        <div v-if="registerStep === 2" id="register-step2" class="t-register-step2">
          <a-text>
            <p>
              {{
                `${registerTargetText}をお申し込みいただくには、以下の「電話等サービス契約約款」と「${registerTargetText}重要事項」の内容をご確認の上、お申し込みボタンをクリックしてください。`
              }}
            </p>
          </a-text>
          <br />
          <a-text :center="true">
            <p>
              <a
                id="termURL"
                href="https://www.ntt.com/content/dam/nttcom/hq/jp/about-us/disclosure/tariff/pdf/c01.pdf"
                target="_blank"
                :style="`color: ${termClicked ? 'gray' : 'blue'}`"
                @click="termClicked = true"
                >電話等サービス契約約款</a
              >
            </p>
            <p style="margin-top: 0.5em">
              <a
                id="precautionURL"
                :href="juuyousetumeiUrl"
                target="_blank"
                :style="`color: ${precautionClicked ? 'gray' : 'blue'}`"
                @click="precautionClicked = true"
                >{{ `${registerTargetText}重要事項説明書` }}</a
              >
            </p>
          </a-text>
        </div>
        <div v-if="registerStep === 3" id="register-step3" class="t-register-step3">
          <a-text>
            <p>{{ `申し込む${registerTargetText}番号を選択してください。` }}</p>
          </a-text>
          <br />
          <div v-if="registerStep1SelectedValue === 'free-dial'" id="free-dial-number" style="display: flex">
            <div id="free-dial-0120" style="margin-right: 0.5em">
              <a-radio
                v-for="number of stockTelNumber0120"
                :id="`radioFreeDial${number}`"
                :key="number"
                v-model="registerNumber"
                name="registerNumber"
                :value="number"
                :label="number"
              />
            </div>
            <div id="free-dial-0800" style="margin-left: 0.5em">
              <a-radio
                v-for="number of stockTelNumber0800"
                :id="`radioFreeDial${number}`"
                :key="number"
                v-model="registerNumber"
                name="registerNumber"
                :value="number"
                :label="number"
              />
            </div>
          </div>
          <div v-if="registerStep1SelectedValue === 'navi-dial'" id="navi-dial-number">
            <div id="navi-dial-0120">
              <a-radio
                v-for="number of stockTelNumber0570"
                :id="`radioNaviDial${number}`"
                :key="number"
                v-model="registerNumber"
                name="registerNumber"
                :value="number"
                :label="number"
              />
            </div>
          </div>
          <br />
          <a-text>
            <p>このサイトで表示される番号以外をご希望の場合は、以下までお問合せください。</p>
          </a-text>
          <a-text>
            <p>
              連絡先：NTTコミュニケーションズ高度電話カスタマーセンター
              　　　　0120-260260（受付時間：平日午前9時～午後5時）
            </p>
          </a-text>
        </div>
        <template v-if="registerStep === 2 || registerStep === 3" #footer>
          <!-- button for step2 -->
          <a-button
            v-if="registerStep === 2"
            id="registerModalStep2RegisterBtn"
            variant="block"
            color="primary"
            label="申し込み"
            size="small"
            :disabled="!(termClicked && precautionClicked)"
            @click="registerStep = 3"
          />
          <a-button
            v-if="registerStep === 2"
            id="registerModalStep2CancelBtn"
            variant="outlined"
            color="grey"
            label="キャンセル"
            size="small"
            @click="registerModalVisible = false"
          />
          <!-- button for step3 -->
          <a-button
            v-if="registerStep === 3"
            id="registerModalStep3OKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="
              registerStep = 4;
              registerModalVisible = false;
              registerModalVisibleStep4 = true;
            "
          />
          <a-button
            v-if="registerStep === 3"
            id="registerModalStep3CancelBtn"
            variant="outlined"
            color="grey"
            label="キャンセル"
            size="small"
            @click="registerModalVisible = false"
          />
        </template>
      </o-modal>
    </teleport>
    <!-- 申し込みStep4 -->
    <teleport to="body">
      <o-modal
        id="registerStep4Modal"
        v-model:visible="registerModalVisibleStep4"
        class="o-modal-remove-phone-number-confirmation t-number-mgmt-general"
        footer-variant="confirmation"
        width="800px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
      >
        <a-text :center="true">
          <p>以下の番号の契約および請求情報は以下となります。</p>
          <br />
          <p>お申し込み番号：　{{ registerNumber }}</p>
          <p>開通予定日：　{{ openingDate }}</p>
          <div class="t-custom-tbl">
            <table>
              <tr>
                <th rowspan="10">契約情報</th>
                <td>契約電話番号</td>
                <td>{{ contractedPhonenumber }}</td>
              </tr>
              <tr>
                <td>
                  契約回線数
                  <a-icon
                    icon="help-outline"
                    color="black"
                    style="cursor: pointer"
                    @click="numberOfLinesHintInvisible = true"
                  />
                </td>
                <td style="padding-left: 5px">
                  <div style="display: flex">
                    <div>
                      <a-text-field
                        id="registerModalStep4NumberOfLines"
                        v-model="numberOfLines"
                        class="m-user-invitation-item__fields-name-input"
                        name="contracted-lines"
                        type="number"
                        :disabled="isLoading"
                        :onkeypress="handleKeypressOnlyNumber"
                        :oninput="handleOninputNumberOfLines(numberOfLines)"
                      />
                    </div>
                    <div><br /><span>※1~100の半角数字をご入力下さい</span></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>ご契約者名</td>
                <td>
                  {{
                    companyInfo.businessType === 'individual'
                      ? companyInfo.adminName
                        ? companyInfo.adminName.replace('_', '')
                        : ''
                      : companyInfo.companyName
                  }}
                </td>
              </tr>
              <tr>
                <td>カナ氏名</td>
                <td>{{ companyInfo.adminKanaName ? companyInfo.adminKanaName.replace('_', '') : '' }}</td>
              </tr>
              <tr>
                <td>氏名</td>
                <td>{{ companyInfo.adminName ? companyInfo.adminName.replace('_', '') : '' }}</td>
              </tr>
              <tr>
                <td>会社名</td>
                <td>{{ companyInfo.companyName }}</td>
              </tr>
              <tr>
                <td>電話番号</td>
                <td>{{ companyInfo.adminPhoneNumber }}</td>
              </tr>
              <tr>
                <td>メールアドレス</td>
                <td>{{ companyInfo.adminEmail }}</td>
              </tr>
              <tr>
                <td>郵便番号</td>
                <td>{{ companyInfo.adminPostCode }}</td>
              </tr>
              <tr>
                <td>住所</td>
                <td>
                  {{
                    companyInfo.adminAddress1 +
                    companyInfo.adminAddress2 +
                    companyInfo.adminAddress3 +
                    companyInfo.adminAddress4
                  }}
                </td>
              </tr>
              <tr>
                <th rowspan="3">請求書送付先</th>
                <td>郵便番号</td>
                <td>{{ companyInfo.invoicePostCode }}</td>
              </tr>
              <tr>
                <td>住所</td>
                <td>
                  {{
                    companyInfo.invoiceAddress1 +
                    companyInfo.invoiceAddress2 +
                    companyInfo.invoiceAddress3 +
                    companyInfo.invoiceAddress4
                  }}
                </td>
              </tr>
              <tr>
                <td>送付先名</td>
                <td>{{ companyInfo.invoiceName }}</td>
              </tr>
            </table>
          </div>
          <div>
            <p v-if="isFreeDial" align="left">
              ◆フリーダイヤルのご利用は以下の料金がかかります<br />
              初期工事費(税込）：1,100円<br />
              月額基本料(税込）：<br />
              ・契約回線数１の場合：1,100円<br />
              ・契約回線数２以上の場合：2,200円<br />
              通話料：<a
                href="https://www.ntt.com/business/services/voice-video/freedial-navidial/freedial/price.html?msclkid=72a665fcc5d111ec9f73fd83f019d04d"
                target="blank"
                style="color: orange"
                >こちら</a
              >でご確認ください。<br />
            </p>
            <p v-else align="left">
              ◆ナビダイヤルのご利用は以下の料金がかかります<br />
              初期工事費(税込）：1,100円<br />
              月額基本料(税込）：11,000円<br />
              通話料：<a
                href="https://www.ntt.com/business/services/voice-video/freedial-navidial/navidial/price.html#tabMenu"
                target="blank"
                style="color: orange"
                >こちら</a
              >でご確認ください。
            </p>
          </div>
          <a-checkbox
            id="registerModalStep4AgreementCbx"
            v-model="registerAgree"
            :label="`上記の契約/請求情報で${registerTargetText}サービスに申し込むことに同意します。`"
            style="margin-top: 20px"
            :disabled="isLoading"
          />
        </a-text>
        <template #footer>
          <a-button
            id="registerModalStep4OKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            :disabled="!registerAgree || !(numberOfLines > 0 && numberOfLines <= 100) || isLoading"
            @click="handleRegisterFDNDNumber()"
          />
          <a-button
            id="registerModalStep4CancelBtn"
            variant="outlined"
            color="grey"
            label="キャンセル"
            size="small"
            :disabled="isLoading"
            @click="registerModalVisibleStep4 = false"
          />
        </template>
      </o-modal>
    </teleport>
    <!-- 解約 modal -->
    <teleport to="body">
      <o-modal
        id="cancelModal"
        v-model:visible="cancelModalVisible"
        class="o-modal-remove-phone-number-confirmation t-number-mgmt-general t-number-mgmt-general-cancel-modal"
        footer-variant="confirmation"
        width="800px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-header="false"
      >
        <div v-if="cancelStep === 1" id="cancel-step1">
          <a-text :center="true">
            <p id="cancelModal-cancel-number-text">ご利用中の番号</p>
            <p id="cancelModal-cancel-number">{{ cancelFDNDNumber }}</p>
          </a-text>
          <br />
          <a-text>
            <p>■どちらの廃止申し込みですか？</p>
          </a-text>
          <a-radio
            id="radioANCancel"
            v-model="cancelMethod"
            name="cancelMethod"
            value="AN"
            html-label="フリーダイヤルもしくはナビダイヤルの契約を廃止<br />(今後、上記の番号を利用しない)"
          />
          <a-radio
            id="radioDNCancel"
            v-model="cancelMethod"
            name="cancelMethod"
            value="DN"
            html-label="フリーダイヤルもしくはナビダイヤルの契約はそのままで、050番号(ご契約電話番号)との紐づけを廃止<br />(別の電話回線で上記の番号を継続利用)"
          />
        </div>
        <div v-if="cancelStep === 2" id="cancel-step2" class="t-cancel-step2">
          <a-text :center="true">
            <p>フリーダイヤル／ナビダイヤルのご解約</p>
            <p>＜ご解約前に今一度、下記内容をご確認ください＞</p>
          </a-text>
          <br />
          <ol>
            <li>
              <span
                >御社広告物（チラシ、パンフレット）、御社独自のノベルティ（カレンダー、ボールペン等）、社員の名刺、御社オリジナル封筒等に掲載されていませんか。<br />お客さまは広告ツールを見て電話をかけています。<br />★御社の広告物等の回収はお済みでしょうか。</span
              >
            </li>
            <li>
              <span
                >お得意さまが、電話機に番号登録されている場合、連絡先電話番号の変更が必要となります。<br />★電話機に登録した電話番号を変更するのがたいへんです。</span
              >
            </li>
            <li>
              <span
                >お得意さまへご解約のご連絡はお済みですか。<br />★ご解約することで、御社の企業イメージダウンにつながります。<br />★新しい連絡先番号がお得意さまに浸透するのに時間がかかります。大きなビジネスチャンスを逃してしまいます。</span
              >
            </li>
            <li>
              <span
                >ご解約後に、再利用いただく予定は無いでしょうか。<br />★再利用いただく場合、お得意さまへの周知のため広告ツールをもう一度作成しなければなりません。</span
              >
            </li>
          </ol>
          <br />
          <a-text>
            <span>ご解約前に、上記の内容をご参考にセルフチェックすることをお勧めします。</span>
          </a-text>
        </div>
        <div v-if="cancelStep === 3" id="cancel-step3">
          <a-text :center="true">
            <p>廃止申し込み</p>
            <br />
            <p>廃止お申し込み番号：　{{ cancelFDNDNumber }}</p>
            <p>
              廃止種別：　{{
                cancelMethod === 'AN'
                  ? 'フリーダイヤルもしくはナビダイヤルの契約を廃止'
                  : 'フリーダイヤルもしくはナビダイヤルの契約はそのままで、050番号（ご契約電話番号）との紐づけを廃止'
              }}
            </p>
            <p>廃止予定日：　{{ openingDate }}</p>
          </a-text>
          <div class="t-custom-tbl">
            <table>
              <tr>
                <th rowspan="7">契約情報</th>
                <td>契約電話番号</td>
                <td>{{ contractedPhonenumber }}</td>
              </tr>
              <tr>
                <td>契約名</td>
                <td>
                  {{
                    companyInfo.businessType === 'individual'
                      ? companyInfo.adminName
                        ? companyInfo.adminName.replace('_', '')
                        : ''
                      : companyInfo.companyName
                  }}
                </td>
              </tr>
              <tr>
                <td>カナ氏名</td>
                <td>{{ companyInfo.adminKanaName ? companyInfo.adminKanaName.replace('_', '') : '' }}</td>
              </tr>
              <tr>
                <td>氏名</td>
                <td>{{ companyInfo.adminName ? companyInfo.adminName.replace('_', '') : '' }}</td>
              </tr>
              <tr>
                <td>会社名</td>
                <td>{{ companyInfo.companyName }}</td>
              </tr>
              <tr>
                <td>電話番号</td>
                <td>{{ companyInfo.adminPhoneNumber }}</td>
              </tr>
              <tr>
                <td>メールアドレス</td>
                <td>{{ companyInfo.adminEmail }}</td>
              </tr>
            </table>
          </div>
          <br />
          <a-text>
            <p>
              {{
                `${cancelTargetText}の契約の廃止後ガイダンスで新しい連絡先等を設定したい場合には、以下までお問い合わせください。`
              }}
            </p>
            <p>　　連絡先：NTTコミュニケーションズ高度電話カスタマーセンター</p>
            <p>　　　　　　0120-260260（受付時間：平日午前9時～午後5時）</p>
          </a-text>
          <br />
          <a-text>
            <p>
              ・廃止するフリーダイヤルのご契約電話番号が、上記に表示されている050番号1番号だけの場合には、<br />
              フリーダイヤル番号のご契約の廃止となります。<br />
              (フリーダイヤルのご契約条件として、最低1番号の電話番号が必要です)<br /><br />
            </p>
            <p>
              ・050番号(ご契約電話番号)との紐づけ廃止のお手続きの完了後、ご契約中のフリーダイヤルについての<br />
              各種設定につきましては、下記までお問い合わせください。<br /><br />
            </p>
          </a-text>
          <a-text :center="true">
            <p>
              連絡先：NTTコミュニケーションズ高度電話カスタマーセンター<br />
              0120-260260（受付時間：平日午前9時～午後5時）
            </p>
          </a-text>
          <a-checkbox
            id="cancelModalStep3AgreementCbx"
            v-model="cancelAgree"
            :label="`上記の内容で${cancelTargetText}サービスの廃止を申し込むことに同意します。`"
            style="margin-top: 20px"
            :disabled="isLoading"
          />
        </div>
        <template #footer>
          <a-button
            id="cancelModalOKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            :disabled="isLoading || (cancelStep === 3 && !cancelAgree)"
            @click="
              if (cancelStep === 3) {
                handleCancelFDNDNumber();
              } else if (cancelMethod === 'DN' && cancelStep === 1) {
                cancelStep = cancelStep + 2;
              } else {
                cancelStep++;
              }
            "
          />
          <a-button
            id="cancelModalCancelBtn"
            variant="outlined"
            color="grey"
            label="キャンセル"
            size="small"
            :disabled="isLoading"
            @click="
              cancelModalVisible = false;
              showInfoModal('フリーダイヤルもしくはナビダイヤル番号の廃止申し込みをキャンセルしました。');
            "
          />
        </template>
      </o-modal>
    </teleport>
    <!-- Info modal -->
    <teleport to="body">
      <o-modal
        id="infoModal"
        v-model:visible="infoModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="500px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-header="false"
      >
        <!-- <template #title>{{ infoModalTitle }}</template> -->
        <a-text>
          <!-- eslint-disable -->
          <span v-html="infoModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="infoModalOKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="infoModalVisible = false"
          />
        </template>
      </o-modal>
    </teleport>
    <!-- Help modal -->
    <teleport to="body">
      <o-modal
        id="helpModal"
        v-model:visible="helpModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <template #title>フリーナビダイヤル/ナビダイヤルサービスのご案内</template>
        <a-text>・ この画面ではフリーダイヤル/ナビダイヤルの新規/廃止申込を行うことができます。</a-text>
        <a-text>・ 新規/廃止以外の各種変更のお申し込み（オプション追加等）は、下記までお問い合わせください。</a-text>
        <a-text>・ フリーダイヤル/ナビダイヤルのサービス内容についてはこちらを参照ください。</a-text><br />
        <a-text>NTTコミュニケーションズ　高度電話カスタマーセンター</a-text>
        <a-text :center="true">0120-260260</a-text>
        <a-text :center="true">受付時間： 平日午前9時～午後5時）</a-text>
      </o-modal>
    </teleport>
    <!-- Hint for numberOfLines -->
    <teleport to="body">
      <o-modal
        id="numberOfLinesHintModal"
        v-model:visible="numberOfLinesHintInvisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :show-close="true"
      >
        <template #title>契約回線数について</template>
        <a-text>
          <p>
            契約回線数とは、同時に受付できる回線数のことです。本サイトでお申し込みできる契約回線数は100回線までです。それ以上の契約回線数をご希望の場合は、高度電話カスタマーセンターまでお問い合わせください。
          </p>
        </a-text>
      </o-modal>
    </teleport>
    <!-- add 050 number modal -->
    <teleport to="body">
      <o-modal
        id="add050NumberModal"
        v-model:visible="add050NumberModal.visible"
        class="o-modal-remove-phone-number-confirmation t-number-mgmt-general"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
      >
        <template #title>{{ add050NumberModal.step === 1 ? '追加番号選択' : '追加番号確認' }}</template>
        <div v-if="add050NumberModal.step === 1" class="t-add-number-step1">
          <a-text>
            <p id="add050NumberModal-add-text">追加する番号を選択してください。</p>
          </a-text>
          <br />
          <a-radio
            v-for="(number, index) of number050List"
            :id="`radio050Number${index}`"
            :key="number"
            v-model="add050NumberModal.selected050Number"
            name="selected050Number"
            :value="number"
            :label="number"
          />
        </div>
        <div v-if="add050NumberModal.step === 2" class="t-add-number-step2">
          <a-text color="orange" weight="bold">追加番号: {{ add050NumberModal.selected050Number }}</a-text>
          <br />
          <a-text>上記050番号を追加します。よろしければ追加ボタンを押してください。</a-text>
          <a-text>※電話番号利用料が加算されますのでご確認の上追加をお願いします。</a-text>
        </div>
        <template #footer>
          <a-button
            v-if="add050NumberModal.step === 1"
            id="add050NumberModalOKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            :disabled="!add050NumberModal.selected050Number"
            @click="add050NumberModal.step = 2"
          />
          <a-button
            v-if="add050NumberModal.step === 1"
            id="add050NumberModalCancelBtn"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="add050NumberModal = {}"
          />
          <a-button
            v-if="add050NumberModal.step === 2"
            id="add050NumberModalBackBtn"
            variant="outlined"
            color="primary"
            label="番号一覧に戻る"
            size="small"
            :disabled="add050NumberModal.isLoading"
            @click="add050NumberModal.step = 1"
          />
          <a-button
            v-if="add050NumberModal.step === 2"
            id="add050NumberModalAddBtn"
            variant="block"
            color="primary"
            label="追加"
            size="small"
            :disabled="add050NumberModal.isLoading"
            @click="handleAdd050Number()"
          />
        </template>
      </o-modal>
    </teleport>
    <!-- edit number name modal -->
    <teleport to="body">
      <o-modal
        id="editNumberNameModal"
        v-model:visible="editNumberNameModal.visible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        z-index="9998"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-header="false"
      >
        <a-text color="orange" weight="bold" align="center">
          <h3 id="editNumberNameModal-select-050-number">電話番号：{{ editNumberNameModal.selected050Number }}</h3>
        </a-text>
        <a-text v-if="editNumberNameModal.step === 2" color="orange" weight="bold" align="center">
          <h3 id="editNumberNameModal-number-name">番号名称：{{ editNumberNameModal.numberName }}</h3>
        </a-text>
        <div v-if="editNumberNameModal.step === 1">
          <a-text align="center">
            <h3 id="editNumberNameModal-number-name-input">上記050番号に設定する名称を入力してください</h3>
          </a-text>
          <br />
          <a-text-field
            id="numberNameInput"
            v-model="editNumberNameModal.numberName"
            placeholder="番号名称"
          ></a-text-field>
        </div>
        <div v-if="editNumberNameModal.step === 2">
          <a-text align="center">
            <h3 id="editNumberNameModal-number-name-completed">上記の通り名称を設定しました。</h3>
          </a-text>
          <br />
        </div>
        <template #footer>
          <a-button
            v-if="editNumberNameModal.step === 1"
            id="editNumberNameModalSaveBtn"
            variant="block"
            color="primary"
            label="保存"
            size="small"
            @click="handleEditNumberName()"
          />
          <a-button
            v-if="editNumberNameModal.step === 1"
            id="editNumberNameModalCancelBtn"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="editNumberNameModal = {}"
          />
          <a-button
            v-if="editNumberNameModal.step === 2"
            id="editNumberNameModalOKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="editNumberNameModal = {}"
          />
        </template>
      </o-modal>
    </teleport>
    <!-- cancel 050 number modal -->
    <teleport to="body">
      <o-modal
        id="cancel050NumberModal"
        v-model:visible="cancel050NumberModal.visible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-header="false"
      >
        <a-text color="orange" weight="bold" align="center">
          <h4 id="cancel050NumberModal-selected-050-number">
            廃止対象050番号：{{ cancel050NumberModal.selected050Number }}
          </h4>
        </a-text>
        <div v-if="cancel050NumberModal.step === 1">
          <a-text align="center">
            <span>上記050番号を廃止します。よろしければ廃止ボタンを押してください。</span>
          </a-text>
          <br />
          <a-text align="center">
            <p>※注意！</p>
            <p>一度廃止すると再度利用することはできませんのでご注意ください</p>
          </a-text>
        </div>
        <div v-if="cancel050NumberModal.step === 2">
          <a-text align="center">
            <span>上記050番号の廃止処理が完了しました。</span>
          </a-text>
        </div>
        <template #footer>
          <a-button
            v-if="cancel050NumberModal.step === 1"
            id="cancel050NumberModalSaveBtn"
            variant="block"
            color="primary"
            label="廃止"
            size="small"
            :disabled="cancel050NumberModal.isLoading"
            @click="handleCancel050Number()"
          />
          <a-button
            v-if="cancel050NumberModal.step === 1"
            id="cancel050NumberModalCancelBtn"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            :disabled="cancel050NumberModal.isLoading"
            @click="cancel050NumberModal = {}"
          />
          <a-button
            v-if="cancel050NumberModal.step === 2"
            id="cancel050NumberModalOKBtn"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="cancel050NumberModal = {}"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';

import { POINT } from '@/libs/constants';
import { utils } from '@/common/utils.js';
import { mapActions } from 'vuex';

export default {
  name: 't-number-mgmt-general',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      stockTelNumber0120: [],
      stockTelNumber0800: [],
      stockTelNumber0570: [],
      registerNumber: '',
      openingDate: '',
      registerAgree: false,
      registerModalVisible: false,
      registerModalVisibleStep4: false,
      registerStep: 0,
      registerStep1SelectedValue: '',
      termClicked: false,
      precautionClicked: false,
      numberOfLinesHintInvisible: false,
      numberOfLines: 100,
      companyInfo: {},
      contractedPhonenumber: '',
      isLoading: false,
      infoModalVisible: false,
      infoModalTitle: '',
      infoModalContent: '',
      cancelModalVisible: false,
      cancelStep: '',
      cancelFDNDNumber: '',
      cancelMethod: 'DN',
      cancelAgree: false,
      dataTableEmptyText: '',
      number050List: [],
      is050NumberFull: false,
      add050NumberModal: {},
      HYPHEN: 'ー', // 全角ハイフン
      editNumberNameModal: {},
      activeNumberCount: 0,
      cancel050NumberModal: {},
      helpModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-number-mgmt-general');
      return `${baseClassName} ${this.class}`.trim();
    },
    authInfo() {
      return this.$store.state.user.authInfo;
    },
    isAllowAccess() {
      return this.authInfo === 'supervisor' || this.authInfo === 'manager';
    },
    isAllowModify() {
      return this.authInfo === 'supervisor';
    },
    canEditNumberName() {
      return this.authInfo === 'supervisor' || this.authInfo === 'manager';
    },
    twilioNumberStatusList() {
      return {
        allocated: '利用中',
        suspended: '利用停止',
        aging: '廃止済',
      };
    },
    customerFDNDStatusList() {
      return {
        'SO-Processing': '申し込み処理中',
        allocated: '利用中',
        'CancelSO-Processing': '廃止処理中',
        unavailable: '廃止済',
      };
    },
    isFreeDial() {
      return this.registerStep1SelectedValue === 'free-dial';
    },
    registerTargetText() {
      return this.registerStep1SelectedValue === 'free-dial' ? 'フリーダイヤル' : 'ナビダイヤル';
    },
    juuyousetumeiUrl() {
      const free =
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/kiyaku_freedial.pdf';
      const navi =
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/kiyaku_navidial.pdf';
      return this.registerStep1SelectedValue === 'free-dial' ? free : navi;
    },
    cancelTargetText() {
      if (!this.cancelFDNDNumber) return '';
      const headNumber = this.cancelFDNDNumber.substring(0, 4);
      let type;
      if (['0120', '0800'].includes(headNumber)) {
        return 'フリーダイヤル';
      } else if (headNumber === '0570') {
        return 'ナビダイヤル';
      }
      return '';
    },
  },
  created() {
    if (!this.isAllowAccess) {
      this.$router.push({
        path: '/permission-denied',
      });
    }
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.$router.push({
        path: '/permission-denied',
      });
    }
    this.getNumberList();
    // 新規050番号追加のためステータスがreadyの050番号一覧取得
    if (this.isAllowModify) this.getReady050NumberList();
  },
  async mounted() {},
  methods: {
    ...mapActions(['updateLoginInfo']),
    getReady050NumberList() {
      this.postRequest('/numbermgmt/getReady050NumberList')
        .then(res => {
          if (res.status === 'success') {
            this.number050List = res.data;
          } else {
            throw new Error('Get 050 number error.');
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.fetchReady050NumberListError);
        });
    },
    getNumberList() {
      this.postRequest('/numbermgmt/getlistgeneral')
        .then(res => {
          this.tableData = [];
          if (res.status === 'failed') throw 'Get list failed.';
          this.activeNumberCount = 0;
          for (const row of res.data.numberInfoArr) {
            this.tableData.push({
              number: row.number.replace('+81', '0'),
              companyID: row.companyID,
              FDNDNumber: row.customerFDNDStatus === 'unavailable' ? '未設定' : row.customerFDNDNumber || '未設定',
              actionButton:
                row.customerFDNDStatus === 'allocated'
                  ? 'cancel' //  cancel: 解約
                  : !row.customerFDNDStatus || row.customerFDNDStatus === 'unavailable'
                  ? 'application' // application: 申し込み;
                  : null,
              numberStatus: this.twilioNumberStatusList[row.status],
              numberUpdateDate: row.updateDate,
              FDNDNumberStatus: this.customerFDNDStatusList[row.customerFDNDStatus],
              FDNDNumberUpdateDate: row.customerFDNDUpdateDate,
              numberName: row.numberName,
              statusRaw: row.status, // status of 050 number(allocated or suspended); TODO confirm status of 050 number
              FDNDNumberStatusRaw: row.customerFDNDStatus, // status of fdnd number(allocated or unavailable)
              suspendedDate: row.suspendedDateStr,
            });
            if (row.status === 'allocated') this.activeNumberCount++;
          }
          this.stockTelNumber0120 = res.data.stockTelNumber0120;
          this.stockTelNumber0800 = res.data.stockTelNumber0800;
          this.stockTelNumber0570 = res.data.stockTelNumber0570;
          this.openingDate = res.data.openingDate;
          this.companyInfo = res.data.companyInfo;
          // 検索結果が0件の場合
          if (this.tableData.length === 0) {
            this.dataTableEmptyText = messageContent.numbermgmtDataTableEmptyText;
          }
          this.is050NumberFull = this.activeNumberCount >= 20;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.numbermgmtGetNumberError);
        });
    },
    handleEditNumberName() {
      const data = {
        phonenumber: this.editNumberNameModal.selected050Number,
        numberName: this.editNumberNameModal.numberName || '',
      };
      // Validate number name
      if (data.numberName.length > 0 && !data.numberName.match(/^[^\x01-\x7E\xA1-\xDF]+$/)) {
        this.showErrorModal(messageContent.requireFullWidthCharacter);
        return;
      }
      if (data.numberName.length > 50) {
        this.showErrorModal(messageContent.requireUnderMaximumNumberOfCharacters('番号名称', 50));
        return;
      }
      this.postRequest('/numbermgmt/editNumberName', data)
        .then(res => {
          if (res.status === 'success') {
            this.getNumberList();
            this.editNumberNameModal.step = 2;
          } else {
            throw new Error('Edit number name failed');
          }
        })
        .catch(err => {
          console.log(err);
          this.editNumberNameModal = {};
          this.showErrorModal(messageContent.editNumberNameError);
        });
    },
    handleCancel050ButtonClick(row) {
      if (this.activeNumberCount === 1) {
        this.showInfoModal(messageContent.canNotCancel050NumberDueToOneLeft);
        return;
      }
      if (['SO-Processing', 'allocated'].includes(row.FDNDNumberStatusRaw)) {
        this.showInfoModal(messageContent.canNotCancel050NumberDueToFDNDLinking);
        return;
      }
      this.cancel050NumberModal = {
        visible: true,
        step: 1,
        selected050Number: row.number,
      };
    },
    handleCancel050Number() {
      this.cancel050NumberModal.isLoading = true;
      this.postRequest('/numbermgmt/cancel050Number', { phonenumber: this.cancel050NumberModal.selected050Number })
        .then(res => {
          if (res.status === 'success') {
            const loginInfo = {};
            Object.assign(loginInfo, this.userData);
            // Merge processed user data with user data in the store
            // Make sure updated data also update, and un-updated fields be kept in the store
            const storeUserData = this.$store.state.user;
            for (const key in storeUserData) {
              if (typeof loginInfo[key] === 'undefined' || loginInfo[key] === null) {
                loginInfo[key] = storeUserData[key];
              }
            }
            loginInfo['phoneNumber'] = res.phonenumber;
            this.updateLoginInfo(loginInfo);

            this.getNumberList();
            this.cancel050NumberModal.step = 2;
          } else {
            if (res.message) {
              throw res.message;
            } else {
              throw messageContent.cancel050NumberError;
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.cancel050NumberModal = {};
          this.showErrorModal(err);
        });
    },
    handleRegisterFDNDNumber() {
      this.isLoading = true;
      const data = {
        customerFDNDNumber: this.registerNumber,
        numberOfLines: this.numberOfLines,
        phonenumber: this.contractedPhonenumber,
      };
      this.postRequest('/numbermgmt/registerfdndnumber', data)
        .then(res => {
          if (res.status === 'failed') throw 'Error. Check log for more details';
          this.getNumberList();
          this.registerModalVisibleStep4 = false;
          this.numberOfLines = 100;
          this.registerAgree = false;
          this.isLoading = false;
          const msg = messageContent.fdndApplyOK(this.registerTargetText);
          this.showInfoModal(msg);
        })
        .catch(err => {
          console.log(err);
          this.registerModalVisibleStep4 = false;
          this.showErrorModal(messageContent.numbermgmtSaveNumberError);
          this.isLoading = false;
        });
    },
    handleCancelFDNDNumber() {
      this.isLoading = true;
      const data = {
        customerFDNDNumber: this.cancelFDNDNumber,
        phonenumber: this.contractedPhonenumber,
        deleteFDNDType: this.cancelMethod,
      };
      this.postRequest('/numbermgmt/cancelfdndnumber', data)
        .then(res => {
          if (res.status === 'failed') throw 'Error. Check log for more details';
          this.getNumberList();
          this.cancelModalVisible = false;
          this.cancelAgree = false;
          this.isLoading = false;
          const msg = messageContent.fdndCancelOK(this.cancelTargetText);
          this.showInfoModal(msg);
        })
        .catch(err => {
          console.log(err);
          this.registerModalVisibleStep4 = false;
          this.showErrorModal(messageContent.numbermgmtSaveNumberError);
          this.isLoading = false;
        });
    },
    showInfoModal(content) {
      this.infoModalTitle = messageContent.infoModalTitle;
      this.infoModalVisible = true;
      this.infoModalContent = content;
    },
    showErrorModal(message) {
      this.infoModalVisible = true;
      this.infoModalTitle = messageContent.errorModalTitle;
      this.infoModalContent = message;
    },
    handleKeypressOnlyNumber(event) {
      return event.charCode >= 48 && event.charCode <= 57;
    },
    handleOninputNumberOfLines(value) {
      this.numberOfLines = value ? Math.round(Number(value)).toString() : '';
    },
    handleAdd050Number() {
      this.add050NumberModal.isLoading = true;
      this.postRequest('/numbermgmt/addNew050Number', { phonenumber: this.add050NumberModal.selected050Number })
        .then(res => {
          if (res.status === 'success') {
            this.getNumberList();
            this.getReady050NumberList();
            this.add050NumberModal = {};
            this.showInfoModal(messageContent.number050Added);
          } else if (res.status === 'checkSoStatus') {
            this.add050NumberModal = {};
            this.showErrorModal(messageContent.alertNowApplying3());
          } else {
            throw new Error('Add number failed');
          }
        })
        .catch(err => {
          console.log(err);
          this.add050NumberModal = {};
          this.showErrorModal(messageContent.add050NumberError);
        });
    },
    async handleClickAddNew050Number() {
      // 変更SO承認待ちのとき、050番号を追加できない
      const soStatusResult = await this.checkSoStatus();
      if (!soStatusResult) {
        return;
      }

      if (this.is050NumberFull) {
        this.showInfoModal(messageContent.number050AlreadyFull);
      } else {
        this.add050NumberModal.visible = true;
        this.add050NumberModal.step = 1;
      }
    },
    checkSoStatus: async function () {
      return await this.postRequest('/contract/checksostatus', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.soStatusFlag = true;
            this.showErrorModal(messageContent.alertNowApplying3());
            return false;
          }
          this.soStatusFlag = false;
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
  },
};
</script>
